import {
  SocialMedia,
  SocialMediaEntry,
  SocialMediaPlatform,
} from "@shared/lib/types/influencer";

import styles from "../styles.module.scss";
import { Avatar, Col, Divider, Drawer, Modal, Row, Space } from "antd";
import { Button } from "@shared/ui/Button";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { getPlatformIcon } from "@shared/lib/utils/getPlatformIcon";
import { useDeLinkSocialMedia } from "@entities/influencer/lib/hooks/useDelinkSocialMedia";
import { useLinkSocialMedia } from "@entities/influencer/lib/hooks/useLinkSocialMedia";
import { useEffect, useState } from "react";
import { ToastService } from "@shared/lib/services";
import { SocialMediaForm } from "./SocialMediaForm";
import { ThirdPInfluencer } from "@features/ThirdPInfluencer/ThirdPInfluencer";
import { SocialMediaInfluencerComp } from "@features/socialMediaInfluencer/SocialMediaInfluencerComp";
import { useGetInfluencerStore } from "@entities/discovery/lib/store/useGetInfluencerStore";

interface Props {
  socialMedias: SocialMediaEntry[];
  influencerId: string;
}
export function SocialMediaList({ socialMedias, influencerId }: Props) {
  const { isDelinking, isDelinked, deLinkSocialMedia } = useDeLinkSocialMedia();
  const { isLinked, isLinking, linkSocialMedia } = useLinkSocialMedia();
  const [deletedReviewId, setdeletedReviewId] = useState<string>("");
  const [reviewModalProps, setReviewModalVisible] = useState<boolean>(false);
  const [socialMediaDrawerId, setSocialMediaDrawerId] = useState<string>("");
  const selectedSocialMedia = socialMedias.find(
    (socialMedia) => socialMedia?.socialMediaLinkageId === socialMediaDrawerId
  );

  const { facets, fetchFacets } = useGetInfluencerStore();

  const handleDelete = (reviewId: string) => {
    setdeletedReviewId(reviewId);
    deLinkSocialMedia({ influencerId, socialMediaLinkageId: reviewId });
  };

  const handleAdd = (values: Partial<SocialMedia>) => {
    linkSocialMedia({
      influencerId,
      socialMedia: { ...values } as SocialMedia,
    });
  };
  useEffect(() => {
    if (isLinked) {
      ToastService.success("Social Media Added");
      setReviewModalVisible(false);
    }
  }, [isLinked]);

  useEffect(() => {
    if (isDelinked) {
      ToastService.success("Social Media Deleted");
      setdeletedReviewId("");
    }
  }, [isDelinked]);

  useEffect(() => {
    fetchFacets();
  }, []);

  return (
    <div className={styles.card}>
      <Space
        style={{
          justifyContent: "space-between",
          width: "100%",
          alignItems: "start",
          marginBottom: "12px",
        }}
      >
        <div className={styles.permTitle}>Social Medias</div>
        <Button
          variant="outlined"
          size="middle"
          onClick={() => setReviewModalVisible(true)}
          icon={<PlusOutlined />}
          iconPosition="end"
        >
          Add Social Media
        </Button>
      </Space>

      <Divider style={{ margin: 0, marginBottom: 16 }} />
      {socialMedias.length ? (
        <div className={styles.permContent}>
          {socialMedias.map((permItem) => (
            <>
              <PermTile
                socialMedia={permItem}
                handleDelete={handleDelete}
                isLoading={isDelinking}
                selectedId={deletedReviewId}
                handleSelect={(id) => setSocialMediaDrawerId(id)}
              />
              <Divider style={{ margin: 0 }} />
            </>
          ))}
        </div>
      ) : (
        <div>No Social Media found</div>
      )}
      <Modal
        title="Add Social Media"
        open={reviewModalProps}
        onCancel={() => setReviewModalVisible(false)}
        footer={null}
        destroyOnClose
        width={700}
      >
        <SocialMediaForm
          handleAdd={handleAdd}
          isAdding={isLinking}
          socialMediasToDisplay={(facets["platforms"] || [])?.map(
            (item) => item._id
          )}
        />
      </Modal>
      <Drawer
        destroyOnClose
        title={"Influencer Details"}
        open={Boolean(socialMediaDrawerId)}
        onClose={() => {
          setSocialMediaDrawerId("");
        }}
        width={1300}
        footer={null}
      >
        {socialMediaDrawerId && (
          <SocialMediaInfluencerComp
            creatorInfo={{
              image: selectedSocialMedia?.socialMedia?.profilePicUrl,
              name: selectedSocialMedia?.userName,
              username: selectedSocialMedia?.userName,
            }}
            socialMediaInfluencerReq={{
              socialMediaObjectId: socialMediaDrawerId,
            }}
          />
        )}
      </Drawer>
    </div>
  );
}

export function PermTile({
  socialMedia,
  handleDelete,
  isLoading,
  selectedId,
  handleSelect,
}: {
  socialMedia: SocialMediaEntry;
  handleDelete: (reviewId: string) => void;
  selectedId: string;
  isLoading: boolean;
  handleSelect: (id: string) => void;
}) {
  return (
    <Row
      style={{ width: "100%" }}
      justify={"space-between"}
      onClick={() => {
        handleSelect(socialMedia?.socialMedia?._id || "");
      }}
    >
      <Col span={14}>
        <Space style={{ gap: "8px", alignItems: "center" }}>
          <Avatar
            src={socialMedia?.socialMedia?.profilePicUrl || ""}
            size={"large"}
          />

          <div className={styles.permItemDesc}>
            {getPlatformIcon(socialMedia?.platform || "")}
            <span
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                window.open(socialMedia?.socialMedia?.link, "_blank");
              }}
            >
              {socialMedia?.userName}
            </span>
          </div>
        </Space>
      </Col>

      <Col
        span={4}
        style={{
          justifyContent: "flex-end",
          display: "flex",
          height: "max-content",
        }}
      >
        <Button
          icon={<DeleteOutlined />}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleDelete(socialMedia.socialMediaLinkageId);
          }}
          loading={selectedId === socialMedia.socialMediaLinkageId && isLoading}
        ></Button>
      </Col>
    </Row>
  );
}
